import { useEffect, useState } from "react";
import { ArrowLeft, LoaderCircle } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import { useAuth } from "@/auth/AuthContext";
import { supabase } from "@/lib/supabase";

export default function AuthCallback() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Confirming your account…");

  useEffect(() => {
    let active = true;
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      if (data.session || session) {
        navigate("/insights", { replace: true });
      } else if (active) {
        setMessage("This confirmation link has expired or is no longer valid.");
      }
    };
    checkSession();
    return () => { active = false; };
  }, [navigate, session]);

  return (
    <main className="auth-page" data-testid="auth-callback-page">
      <SeoHead title="Confirming your account | Ashwini Patil" description="Confirming an Ashwini Patil account." canonical="https://ashwinipatil.ai/auth/callback" noIndex schemas={[]} />
      <div className="shell auth-shell">
        <div className="auth-card auth-state-card">
          <div className="auth-mark"><LoaderCircle size={19} /></div>
          <div className="section-kicker">Account confirmation</div>
          <h1 className="auth-title">One moment.</h1>
          <p className="auth-copy" data-testid="auth-callback-message">{message}</p>
          {message.includes("expired") && <Link to="/register" className="inline-link" data-testid="auth-callback-register-link"><ArrowLeft size={15} /> Create a new account</Link>}
        </div>
      </div>
    </main>
  );
}
